import Loading from "@/pages/loading";
import { dashboardPersistReduxActions } from "@/redux/actions/dashboardPersist";
import { APP_ROUTES, useAppDispatch } from "@/utils";
import { bnplConsumerGetOrder } from "@payping/redux/actions";
import { useMessagedAsyncRetry } from "@payping/web-components";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import PayGetOrderUnAvailable from "../GetOrder/UnAvailable";
import PrePayCallbackFailedPaymentPage from "./FailedPayment";
import PrePayCallbackSuccessPage from "./Success";

const PrePayCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const trackingCode = searchParams.get("trackingCode") || "";
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const status = searchParams.get("status");

  const { loading, error, value } = useMessagedAsyncRetry(
    () => dispatch(bnplConsumerGetOrder(trackingCode, { isRaw: true })),
    [dispatch, trackingCode],
    {
      success: false,
      error: true,
    },
  );

  useEffect(() => {
    if (!trackingCode) {
      navigate(APP_ROUTES.home.overview.url);
    } else {
      dispatch(dashboardPersistReduxActions.setTrackingCode(trackingCode));
    }
  }, [dispatch, navigate, trackingCode]);

  if (loading || error?.name === "AuthError") {
    return <Loading />;
  }

  // error
  if (error) {
    return <PayGetOrderUnAvailable />;
  }

  if (status !== "0") {
    return <PrePayCallbackFailedPaymentPage />;
  }

  return (
    <PrePayCallbackSuccessPage
      callbackMerchant={value?.merchantRedirectUrl ?? ""}
      merchantName={value?.merchantName ?? ""}
    />
  );
};

export default PrePayCallbackPage;
